export default {"src":"/_next/static/media/add-comment-icon.fe16a502.svg","height":84,"width":84,"blurWidth":0,"blurHeight":0};